import {getTestProps} from '@benchling/js-test-utils';
import {css} from 'aphrodite';
import classNames from 'classnames';
import React, {useRef} from 'react';
import _ from 'underscore';

import {ProcessExecutionType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {sharedStyles} from 'processes/settings/fields/ProcessTaskSchemaFieldConstants';
import CheckboxInput from 'ui-library/inputs/CheckboxInput';
import FieldLabel from 'ui-library/inputs/FieldLabel';
import InputWrapper from 'ui-library/inputs/InputWrapper';

interface IsPropagateWatchersEnabledFieldProps {
  value?: boolean;
  onChange: (value: boolean) => void;
  disabled: boolean;
  executionType: ProcessExecutionType;
}

export default function IsPropagateWatchersEnabledField(
  props: IsPropagateWatchersEnabledFieldProps
): JSX.Element {
  const wrapperIdRef = useRef(_.uniqueId('isPropagateWatchersEnabledWrapper'));
  const checkboxIdRef = useRef(_.uniqueId('isPropagateWatchersEnabledCheckbox'));

  return (
    <div {...getTestProps({component: 'IsPropagateWatchersEnabledField', element: 'root'})}>
      <InputWrapper id={wrapperIdRef.current} label="Watchers" labelStyle={FieldLabel.STYLES.LABEL}>
        {props.executionType === ProcessExecutionType.FLOWCHART ? (
          <div className={classNames(css(sharedStyles.checkboxWrapper), 'editableField')}>
            <CheckboxInput
              id={checkboxIdRef.current}
              className={css(sharedStyles.checkboxField)}
              label={
                <div>
                  <div>Propagate watchers</div>
                  <div className={css(sharedStyles.messageText)}>
                    Watchers will be propagated to this flowchart’s task groups the first time they are added.
                  </div>
                </div>
              }
              checked={props.value ?? false}
              disabled={props.disabled}
              onChange={(e) => {
                props.onChange(e.target.checked);
              }}
            />
          </div>
        ) : (
          <span className={css(sharedStyles.messageText)}>
            Watchers can only be propagated when the execution type is Flowchart.
          </span>
        )}
      </InputWrapper>
    </div>
  );
}
